import React from 'react';
import SKUTiles from 'common-ui-components/dist/components/Organisms/SKUTiles';
import './ShoppingCartItem.scss';

const ShoppingCartItem = props => (
  <div className="sku-tiles">
    <SKUTiles {...props} />
  </div>
);

ShoppingCartItem.defaultProps = {};

export default ShoppingCartItem;
